// extracted by mini-css-extract-plugin
export default {"oferta":"ListonOferta_oferta__DVMlr","noOferta":"ListonOferta_noOferta__ubeDV"};